import { v4 as uuidv4 } from "uuid";
import { MessageType } from "../store/types";

// 每次都是新的
export const createClientUUid = (msgType: MessageType) => {
  return `clientID_${msgType}_${uuidv4()}`;
};

// 添加文本转义函数
export const escapeTextContent = (text: string): string => {
  return text
    .replace(/\\/g, "\\\\") // 转义反斜杠
    .replace(/"/g, '\\"') // 转义双引号
    .replace(/\n/g, "\\n") // 转义换行符
    .replace(/\r/g, "\\r") // 转义回车符
    .replace(/\t/g, "\\t") // 转义制表符
    .replace(/\f/g, "\\f"); // 转义换页符
};
/**
 * 复制文本到剪贴板
 * @param text 要复制的文本
 * @returns 是否复制成功
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  // 验证输入
  if (typeof text !== "string" || !text.trim()) {
    console.warn("复制内容无效");
    return false;
  }

  try {
    // 优先尝试现代 API
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }

    // 降级到传统方法
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.opacity = "0";

    document.body.appendChild(textArea);
    textArea.select();

    const success = document.execCommand("copy");
    document.body.removeChild(textArea);

    return success;
  } catch (error) {
    console.error("复制失败:", error);
    return false;
  }
}
export const generateUniqueId = () => {
  return `${uuidv4()}`;
};

export function createUuid() {
  const uid = (localStorage && localStorage.getItem("U_UID")) || "";
  if (uid) return uid;
  const result = uuidv4();
  localStorage.setItem("U_UID", result);
  return result;
}

// 一次页面会话唯一 ID
export function createSessionId() {
  if (typeof sessionStorage === "undefined") {
    return "";
  }
  const uid = (sessionStorage && sessionStorage.getItem("SESSION_ID")) || "";
  if (uid) return uid;
  const result = uuidv4();
  sessionStorage.setItem("SESSION_ID", result);
  return result;
}
